<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view />
  </div>
</template>

<script src="https://unpkg.com/vue@3/dist/vue.global.js"></script>
<script>
import Cookies from "js-cookie";
export default {
  name: "App",
  // ,provide(){
  //   return {
  //     reload: this.reload
  //   }
  // },
  data() {
    return {
      // isRouterAlive: true
      favicon_href: require("@/assets/favicon.png"),
      ylipin_href: require("@/assets/ylipin.png"),
    };
  },
  created() {
    // 设置初始化的标题和小图标
    let siteName = Cookies.get("view_site_name");
    if (
      siteName == undefined ||
      siteName == "undefined" ||
      siteName == "" ||
      siteName == "null" ||
      siteName == null
    ) {
      siteName = window.location.href.split("/")[2];
    }
    this.setDocumentTitle(siteName);
    // this.setDocumentTitle("如意云仓");
    if (Cookies.get("view_icon") == "www.ylipin.com.ico") {
      this.setFavicon(this.ylipin_href);
    } else {
      this.setFavicon(this.favicon_href);
    }
  },
  methods: {
    // reload(){
    //   this.isRouterAlive = false
    //   this.$nextTick(()=>(this.isRouterAlive = true))
    // }
    setDocumentTitle(title) {
      document.title = title;
    },
    // 设置页面小图标
    setFavicon(href) {
      let link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.getElementsByTagName("head")[0].appendChild(link);
      }
      link.href = href;
    },
  },
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /*background-color: #808080;  灰色的十六进制代码 */
}
</style>



// WEBPACK FOOTER //
// src/App.vue